import { Component, Output, OnInit, Input, EventEmitter } from '@angular/core';
import { trigger, state, style, animate, transition, AnimationEvent } from '@angular/animations';


@Component({
  selector: 'app-tag',
  templateUrl: 'tag.component.html',
  styleUrls: ['tag.component.css'],
  animations: [
    trigger('deleteAnimation', [
      state('prepare', style({ transform: 'scale(0)', opacity: '0' })),
      transition('none => prepare', animate(200)),
    ])
  ]
})
export class TagComponent implements OnInit {
  @Input() tag: any;
  @Output() closed = new EventEmitter<any>();

  deleteState = 'none';

  constructor() { }

  ngOnInit() {
  }

  onTagClicked() {
    this.deleteState = 'prepare';
  }

  onDeleteAnimationDone(event: AnimationEvent, tag: any) {
    if (event.toState === 'prepare') {
      this.closed.emit(tag);
    }
  }
}


// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/questions/tagsComponent/tag/tag.component.ts